import Colors from '@dynatrace/strato-design-tokens/colors';

export const DEFAULT_GANTT_COLORS = {
  background: Colors.Border.Neutral.Default,
  default: 'blue',
};

export const STRIPES_PATTERN_ID = 'strato-gantt-chart-stripes-pattern';
export const DISABLED_PATTERN_SIZE = 2;
export const DISABLED_PATTERN_ANGLE = 45;
export const DEFAULT_BAR_OPACITY = 0.85;
export const DEFAULT_TOOLTIP_MARGIN = 40;

export const DEFAULT_GANTT_LINE_SIZE: 'default' | 'condensed' | 'comfortable' =
  'default';
export const DEFAULT_GANTT_SEGMENT_NAME = 'Segment';

export const GANTT_LINE_SIZE_HEIGHT: Record<
  'default' | 'condensed' | 'comfortable',
  number
> = {
  default: 16, //px
  comfortable: 20, //px
  condensed: 12, //px
};

export const TIMESTAMP_WIDTH = 3;

export const GANTT_CHART_V2_ARIA_LABEL = 'Gantt Chart';
